import { render, staticRenderFns } from "./ListaMonitoramentoAgricola.vue?vue&type=template&id=33be05df&scoped=true&lang=pug"
import script from "./ListaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./ListaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./ListaMonitoramentoAgricola.vue?vue&type=style&index=0&id=33be05df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be05df",
  null
  
)

export default component.exports